import React, { Component } from "react";

import { setOrderStatusRequest } from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { orderStatusList } from "store/OrderDetail/selector";
import { createStructuredSelector } from "reselect";

class OrderStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      color: "",
    };
  }

  componentDidMount() {
    this.setStatusColor(this.props.status);
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    this.setStatusColor(nextprops.status);
  }

  orderStatusChange = (select) => {
    this.props.setOrderStatusRequest(this.props.orderId, select.target.value);
  };

  setStatusColor = (status = this.props.status) => {
    const { color } = this.props.orderStatusList.find(
      (s) => s.value === String(status)
    );
    this.setState({
      color,
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="order-status">
          <select
            value={this.props.status}
            onChange={(e) => this.orderStatusChange(e)}
            className={"form-control " + this.state.color}
            disabled={this.props.disabled}
          >
            {this.props.orderStatusList.map((orderStatus) => (
              <option key={orderStatus.value} value={orderStatus.value}>
                {orderStatus.label}
              </option>
            ))}
          </select>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  orderStatusList: orderStatusList(),
});

const withConnect = connect(mapStatetoProps, {
  setOrderStatusRequest,
});

export default compose(withConnect, withRouter)(OrderStatus);
